import { makeStyles, createStyles } from '@mui/styles';
import { WHITE } from 'src/global/theme/colors';

export const styles = makeStyles(() =>
  createStyles<'root', { backgroundColor?: string }>({
    root: ({ backgroundColor }) => ({
      backgroundColor: backgroundColor,
      color: WHITE,
      padding: "4px 12px",
      borderRadius: 4,
      fontWeight: 700,
      fontSize: 14,
      display: 'table',
      lineHeight: '22px',
      textAlign: 'center',
      minWidth: 110,
    })
  })
);
